import { useState } from "react";
import AddEditForm from "./AddEditForm";
import { IAddEditRoleFormValues } from "../../../Interfaces/roleAndPermissionsInterfaces";
import {
  addRole,
  editRole,
} from "../../../Requests/roleAndPermissionsRequests";
import { toast } from "react-toastify";
import { packetErrorHandler } from "../../../Utils/requestUtils";
import Table from "../../../Tables/RolesAndPermissions//Roles/Table";
import AddIcon from "@mui/icons-material/Add";
import Modal from "../../../Components/Modal/Modal";

const emptyRoleFormValues: IAddEditRoleFormValues = {
  roleId: null,
  roleName: "",
  permissionIds: [],
  isPrivate: false,
};

const Roles = () => {
  const [formValues, setFormValues] =
    useState<IAddEditRoleFormValues | null>(null);

  const [refreshTableFlag, setRefreshTableFlag] = useState(false);

  const [loading, setLoading] = useState(false);

  const changeHandler = (name: string, value: any) => {
    setFormValues((current) =>
      current ? { ...current, [name]: value } : current,
    );
  };

  const getProperFunction = () => {
    if (!formValues) return null;
    if (formValues.roleId) return editRole(formValues);
    return addRole(formValues);
  };

  const btnClickHandler = () => {
    const request = getProperFunction();
    if (!request) return;

    setLoading(true);
    request
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          setFormValues(null);
          setRefreshTableFlag(true);
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <div className="w-full min-h-[600px]">
      {formValues ? (
        <Modal title={formValues?.roleId ? "ویرایش نقش" : "افزودن نقش"}
          UI={
            <AddEditForm
              formValues={formValues}
              onChange={changeHandler}
              onBtnClick={btnClickHandler}
              loading={loading}
              onEditCancel={() => setFormValues(null)}
            />
          }
          onClose={() => setFormValues(null)}
          modalBoxClassName="!min-w-[340px]"
        />
      ) : null}

      <div className="w-fit flex items-center mb-2 mt-5 mr-auto ml-5 gap-3">
        <div
          className="bg-sky-600 rounded-full flex justify-center items-center w-11 h-11 cursor-pointer"
          onClick={() => setFormValues(emptyRoleFormValues)}
        >
          <AddIcon className="text-white" />
        </div>
      </div>

      <div className="mx-auto">
        <Table
          onEdit={setFormValues}
          refreshTableFlag={refreshTableFlag}
          setRefreshTableFlag={setRefreshTableFlag}
        />
      </div>
    </div>
  );
};

export default Roles;
